import { useCallback, useEffect, useState } from 'react';

import { AUTH_TOKEN_CHANGED_EVENT } from '@/lib/auth/constants';
import { getValidAuthToken } from '@/utils/authCompat';

type TokenSource = 'auth0' | 'magic' | null;

type UseAuthTokenReturn = {
  token: string | null;
  isAuthenticated: boolean;
  source: TokenSource;
};

// gloss
export const useAuthToken = (): UseAuthTokenReturn => {
  const [state, setState] = useState<{ token: string | null; source: TokenSource }>(() => {
    const result = getValidAuthToken();
    return result ? { token: result.token, source: result.source } : { token: null, source: null };
  });

  const refresh = useCallback(() => {
    const result = getValidAuthToken();
    setState(result ? { token: result.token, source: result.source } : { token: null, source: null });
  }, []);

  useEffect(() => {
    window.addEventListener('storage', refresh);
    window.addEventListener(AUTH_TOKEN_CHANGED_EVENT, refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener(AUTH_TOKEN_CHANGED_EVENT, refresh);
    };
  }, [refresh]);

  return {
    token: state.token,
    isAuthenticated: !!state.token,
    source: state.source,
  };
};

